import {useContext} from "react";
import {AlertContextValue} from "./AlertContextValue";
import {AlertContext} from "./AlertContext";

export function useAlertContext(): AlertContextValue {
  return useContext(AlertContext);
}
